import { render } from "./Link.vue?vue&type=template&id=76946ff2&ts=true"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"

import "./Link.vue?vue&type=style&index=0&id=76946ff2&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__